import React, { useState } from "react"
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel"
import "pure-react-carousel/dist/react-carousel.es.css"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ArrowRight } from "@icons"
import { useEffect } from "react"
import { classes } from "@utils"

export const ArticleCarousel = ({ content }) => {
  const { images } = content
  const { aCBC } = classes
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const [currentSlideHeight, setCurrentSlideHeight] = useState("100%")

  const getSlideStyle = (currentSlideHeight) => {
    return {
      height: currentSlideHeight === "0px" ? "initial" : currentSlideHeight,
      overflow: "hidden",
    }
  }

  useEffect(() => {
    const currentSlide = document.getElementsByClassName(
      "carousel__slide--visible"
    )
    const currentSlideImgWrapper = currentSlide[0].getElementsByClassName(
      "gatsby-image-wrapper"
    )
    const styles = window.getComputedStyle(currentSlideImgWrapper[0])
    const height = styles.getPropertyValue("height")
    setCurrentSlideHeight(height)
  }, [currentSlideIndex])

  return (
    <>
      <div className={`${aCBC} desktop`}>
        <CarouselProvider
          naturalSlideWidth={976}
          naturalSlideHeight={530}
          totalSlides={images.length}
          visibleSlides={1}
          currentSlide={currentSlideIndex}
          touchEnabled={false}
          dragEnabled={false}
        >
          <Slider>
            {images.map((image, index) => {
              const img = getImage(image.image.gatsbyImageData)
              return (
                <Slide key={index} index={index}>
                  <div style={getSlideStyle(currentSlideHeight)}>
                    <GatsbyImage
                      image={img}
                      alt={image.imageDescription?.imageDescription}
                      style={{
                        height:
                          currentSlideIndex !== index ? "100%" : undefined,
                        borderRadius: ".25rem",
                      }}
                    />
                  </div>
                  <p className={`${aCBC}__desc`}>
                    {image.imageDescription?.imageDescription}
                  </p>
                </Slide>
              )
            })}
          </Slider>
          <div
            className={`${aCBC}__buttons`}
            style={getSlideStyle(currentSlideHeight)}
          >
            <ButtonBack
              onClick={() => setCurrentSlideIndex(currentSlideIndex - 1)}
            >
              <ArrowRight />
            </ButtonBack>
            <ButtonNext
              onClick={() => setCurrentSlideIndex(currentSlideIndex + 1)}
            >
              <ArrowRight />
            </ButtonNext>
          </div>
        </CarouselProvider>
      </div>
      <div className={`${aCBC} mobile`}>
        {images.map((image, index) => {
          const img = getImage(image.image.gatsbyImageData)
          return (
            <div key={index} className={`carousel-mobile`}>
              <GatsbyImage
                image={img}
                alt={image.imageDescription?.imageDescription}
              />

              <p className={`${aCBC}__desc`}>
                {image.imageDescription?.imageDescription}
              </p>
            </div>
          )
        })}
      </div>
    </>
  )
}
